import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import coreService from "@/utils/axios/core-service";
import { API_ENDPOINTS, RESPONSE_STATUSES } from "@/constants/api-endpoints";
import { MARKET_PLACES } from "@/constants/app";

//  Fetch all eBay discount setting data
export const fetchEbayDiscountAllocationData = createAsyncThunk(
  "discountAllocation/fetchAll",
  async (
    {
      page = 0,
      size = 100,
      marketplace = MARKET_PLACES.EBAY,
      body = [
        {
          fieldName: "marketPlace",
          fieldValue: marketplace,
          searchOperator: "LIKE",
        },
      ],
    } = {},
    thunkAPI,
  ) => {
    try {
      const response = await coreService.post(
        `${API_ENDPOINTS.ADMIN.SETTINGS.EBAY.DISCOUNT_ALLOCATION.GET_ALL}?page=${page}&size=${size}&sort=id,asc`,
        body,
      );

      if (response.data?.status == RESPONSE_STATUSES.SUCCESS) {
        return response.data?.data?.content || [];
      }

      return thunkAPI.rejectWithValue("Unexpected response from server");
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.message || "API error");
    }
  },
);
export const createOrUpdateDiscountAllocation = createAsyncThunk(
  "discountAllocation/createOrUpdateDiscountAllocation",
  async ({ payload, page, size, t }, thunkAPI) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await coreService.post(
          API_ENDPOINTS.ADMIN.SETTINGS.EBAY.DISCOUNT_ALLOCATION.CREATE,
          payload,
        );

        if (response.data.status == RESPONSE_STATUSES.CREATED) {
          // 🔥 Refetch after success
          thunkAPI.dispatch(fetchEbayDiscountAllocationData({ page, size }));

          resolve(t("discountSettingsUpdateSuccesfully"));
        } else {
          reject(t("failedToUpdateDiscountSettings"));
        }
      } catch (err) {
        reject(err?.message);
      }
    });
  },
);
//  Slice
const discountAllocationSlice = createSlice({
  name: "discountAllocation",
  initialState: {
    discountAllocationData: [],
    discountAllocationLoading: false,
    discountAllocationError: null,
    submitLoading: false,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchEbayDiscountAllocationData.pending, (state) => {
        state.discountAllocationLoading = true;
        state.discountAllocationError = null;
      })
      .addCase(fetchEbayDiscountAllocationData.fulfilled, (state, action) => {
        state.discountAllocationLoading = false;
        state.discountAllocationData = action.payload;
      })
      .addCase(fetchEbayDiscountAllocationData.rejected, (state, action) => {
        state.discountAllocationLoading = false;
        state.discountAllocationError = action.payload;
        state.discountAllocationData = [];
      })
      // SUBMIT
      .addCase(createOrUpdateDiscountAllocation.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(createOrUpdateDiscountAllocation.fulfilled, (state) => {
        state.submitLoading = false;
      })
      .addCase(createOrUpdateDiscountAllocation.rejected, (state) => {
        state.submitLoading = false;
      });
  },
});

export default discountAllocationSlice.reducer;
